// MODULES
import React from "react";

// HELPERS
import {createClassName} from "@helpers/utils";
import EditableField from "../../../components/EditableField/EditableField";
import fulfillmentCheck from "./ProductPurchase2.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";
import NumberField from "../../../components/NumberField/NumberField";
import StackLayout from "../../../../../components/layouts/StackLayout/StackLayout";
import Button from "../../../../../components/Button/Button";
import AppConfig from "../../../../../classes/AppConfig";
import AbstractAutogiro, {ProductSelectionRow} from "../../Autogiro/AbstractAutogiro";


export default class ProductPurchase2 extends AbstractAutogiro {

	static minimumAmountSingleDeposit = 50000;
	static minimumAmountMonthlyDeposit = 1000;

	static maxNumberOfSelectableProducts = 4;
	static productLabel = "Fond";

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {state} = this;
		const {session} = this.props;

		const classes = createClassName("Cob-Autogiro-ProductPurchase2", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		const textClassSingle = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_single.checked
		});

		const textClassMonthly = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_monthly.checked
		});

		/**
		 * Create rows for selecting funds when you have decided to make either a single deposit
		 * or to start a monthly savings routine.
		 */
		const autogiroSingleFunds = [];
		for (let i = 1; i <= state.autogiroSingleFundsActive; i++) {
			autogiroSingleFunds.push(ProductSelectionRow(this, true, ProductPurchase2.minimumAmountSingleDeposit, ProductPurchase2.minimumAmountMonthlyDeposit, state.products, "single", i));
		}

		const autogiroMonthlyFunds = [];
		for (let i = 1; i <= state.autogiroMonthlyFundsActive; i++) {
			autogiroMonthlyFunds.push(ProductSelectionRow(this, true, ProductPurchase2.minimumAmountSingleDeposit, ProductPurchase2.minimumAmountMonthlyDeposit, state.products, "monthly", i));
		}

		const sheInvestsLogoUrl = AppConfig.get("apiUrl") + "/partner/img?filename=alfa-sheinvest.png";
		const globecapLogoUrl = AppConfig.get("apiUrl") + "/partner/img?filename=alfa-globecap.png";

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<h2>Fondsparande i UCITS-fonder</h2>

				<div style={{
					position: "absolute",
					top: "-35px",
					left: "-170px",
					fontSize: "12px",
					color: "#FFF"
				}}>
					<div style={{marginBottom: "20px", fontWeight: "bold"}}>
						<img src={globecapLogoUrl} alt={""} style={{
							width: "120px",
							height: "120px",
							border: "1px solid #CCC",
							margin: "0 0 5px 0"
						}}/>
						GlobeCap 100
					</div>
					<div style={{fontWeight: "bold"}}>
						<img src={sheInvestsLogoUrl} alt={""} style={{
							width: "120px",
							height: "120px",
							border: "1px solid #CCC",
							margin: "0 0 5px 0"
						}}/>
						She Invest Sweden
					</div>
				</div>

				<p style={{margin: "0 0 10px 0", maxWidth: "620px", fontSize: "14px"}}>
					För att du ska kunna sätta in och ta ut pengar, samt månadsspara i UCITS-fonder via autogiro måste
					ovanstående autogiromedgivande fyllas i.&nbsp;

					{!session.isCompany && (
						<React.Fragment>
							Du kan även bara öppna ett ISK-konto och sedan göra manuella överföringar och handla direkt
							i inloggat läge.
						</React.Fragment>
					)}

					{session.isCompany && (
						<React.Fragment>
							Du kan även bara öppna ett depåkonto och sedan göra manuella överföringar och handla direkt
							i inloggat läge.
						</React.Fragment>
					)}

				</p>

				<div className="payments">
					<CheckboxWithName
						label="Jag vill göra en engånginsättning via Autogiro till följande UCITS-fonder"
						name="checkbox_autogiro_single"
						value={this.props.app.isAutogiroApproved && state.fields.checkbox_autogiro_single.checked ? "yes" : "no"}
						checked={this.props.app.isAutogiroApproved && state.fields.checkbox_autogiro_single.checked}
						disabled={!this.props.app.isAutogiroApproved}
						onChange={this._onCheckboxChange}
					/>

					{this.props.app.isAutogiroApproved && (
						<div className={textClassSingle}>
							<div className="inner">
								<div className="funds">
									<div className="amountField">
										<EditableField
											name="customer_autogiro_single_amount"
											label="Belopp"
											className="amount"
											Component={NumberField}
											value={state.fields.checkbox_autogiro_single.checked ? (state.fields.customer_autogiro_single_amount || "") : ""}
											valid={state.validFields.customer_autogiro_single_amount && state.fields.customer_autogiro_single_amount >= ProductPurchase2.minimumAmountSingleDeposit}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
										/>
										<span>(min. {ProductPurchase2.minimumAmountSingleDeposit.toLocaleString("sv-SE", {minimumFractionDigits: 0})} SEK)</span>
									</div>

									{autogiroSingleFunds}

									{(state.autogiroSingleFundsSharesTotal < 100 ||
										state.autogiroSingleFundsSharesTotal > 100) && (
										<div className="warning">
											<strong>Var god åtgärda:</strong> Summan av fondfördelningen måste vara
											100%
											(just nu {state.autogiroSingleFundsSharesTotal}%).
										</div>
									)}

									<StackLayout fullWidth>
										<Button
											size="small"
											label="Lägg till fond"
											appearance={state.autogiroSingleFundsActive >= ProductPurchase2.maxNumberOfSelectableProducts ? "medium" : "primary"}
											disabled={state.autogiroSingleFundsActive >= ProductPurchase2.maxNumberOfSelectableProducts}
											onClick={this._onAddFund.bind(this, "single")}
											filled
										/>

										<Button
											size="small"
											label="Ta bort sista"
											appearance={state.autogiroSingleFundsActive <= 1 ? "medium" : "danger"}
											disabled={state.autogiroSingleFundsActive <= 1}
											onClick={this._onRemoveFund.bind(this, "single")}
										/>
									</StackLayout>
								</div>
							</div>
						</div>
					)}


					<CheckboxWithName
						label={"Jag vill starta ett månadssparande via Autogiro till följande UCITS-fonder"}
						name="checkbox_autogiro_monthly"
						value={this.props.app.isAutogiroApproved && state.fields.checkbox_autogiro_monthly.checked ? "yes" : "no"}
						checked={this.props.app.isAutogiroApproved && state.fields.checkbox_autogiro_monthly.checked}
						disabled={!this.props.app.isAutogiroApproved}
						onChange={this._onCheckboxChange}
					/>

					{this.props.app.isAutogiroApproved && (
						<div className={textClassMonthly}>
							<div className="inner">
								<div className="funds">
									<div className="amountField">
										<EditableField
											name="customer_autogiro_monthly_amount"
											label="Belopp"
											className="amount"
											Component={NumberField}
											value={state.fields.checkbox_autogiro_monthly.checked ? (state.fields.customer_autogiro_monthly_amount || "") : ""}
											valid={state.validFields.customer_autogiro_monthly_amount && state.fields.customer_autogiro_monthly_amount >= ProductPurchase2.minimumAmountMonthlyDeposit}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
										/>
										<span>(min. {ProductPurchase2.minimumAmountMonthlyDeposit.toLocaleString("sv-SE", {minimumFractionDigits: 0})} SEK)</span>
									</div>

									{autogiroMonthlyFunds}

									{(state.autogiroMonthlyFundsSharesTotal < 100 ||
										state.autogiroMonthlyFundsSharesTotal > 100) && (
										<div className="warning">
											<strong>Var god åtgärda:</strong> Summan av fondfördelningen måste
											vara
											100%
											(just nu {state.autogiroMonthlyFundsSharesTotal}%).
										</div>
									)}

									<StackLayout fullWidth>
										<Button
											size="small"
											label="Lägg till fond"
											appearance={state.autogiroMonthlyFundsActive >= ProductPurchase2.maxNumberOfSelectableProducts ? "medium" : "primary"}
											disabled={state.autogiroMonthlyFundsActive >= ProductPurchase2.maxNumberOfSelectableProducts}
											onClick={this._onAddFund.bind(this, "monthly")}
											filled
										/>

										<Button
											size="small"
											label="Ta bort sista"
											appearance={state.autogiroMonthlyFundsActive <= 1 ? "medium" : "danger"}
											disabled={state.autogiroMonthlyFundsActive <= 1}
											onClick={this._onRemoveFund.bind(this, "monthly")}
										/>
									</StackLayout>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}

	_nameIsinFilterer = ({option}, input) => {
		input = input.toLowerCase();

		let matchesIsinNumber = false;
		if (option.isin) {
			const isin = option.isin.toLowerCase();
			matchesIsinNumber = isin.indexOf(input) === 0;
		}

		const name = option.label.toLowerCase();
		return name.indexOf(input) >= 0 || matchesIsinNumber;
	};

	_renderNameIsinOption = ({label, isin}) => (
		<React.Fragment>
			<div className="name">{label}</div>
			<div className="isin">{isin}</div>
		</React.Fragment>
	);

	_onNameIsinChange = (name, option, value) => {
		const indexKey = name.replace("_name", "_index");
		let fundIndexInArray = name.replace("_name", "");
		fundIndexInArray = parseInt(fundIndexInArray.substring(fundIndexInArray.lastIndexOf("_") + 1), 10) - 1;

		let selectedDropdownIndex = -1;
		for (let i = 0; i < this.state.products.length; i++) {
			const fund = this.state.products[i];
			if (fund.isin === value.isin) {
				selectedDropdownIndex = i;
				break;
			}
		}

		const newStateProps = {
			[indexKey]: selectedDropdownIndex,
			fields: this.state.fields
		};

		if (selectedDropdownIndex > -1) {
			const selectedFund = this.state.products[selectedDropdownIndex];

			if (name.indexOf("_monthly") > -1) {
				newStateProps.fields.customer_autogiro_monthly_funds[fundIndexInArray]["customer_autogiro_monthly_fund_" + (fundIndexInArray + 1) + "_name"] = selectedFund.label;
				newStateProps.fields.customer_autogiro_monthly_funds[fundIndexInArray]["customer_autogiro_monthly_fund_" + (fundIndexInArray + 1) + "_isin"] = selectedFund.isin;

				/**
				 * Update state with new values. We reset the amount field to the same value as it already has because
				 * this triggers a revalidation of the form. This is a hack that works, made because of lack of time.
				 * If you find a better way of triggering revalidation, feel free to change.
				 */
				const resetValue = this.state.fields.customer_autogiro_monthly_amount;
				this.setState(newStateProps, function () {
					// triggers revalidation of form after dropdown value has been set
					CobHelpers.onViewFieldChange.call(this, "customer_autogiro_monthly_amount", resetValue);
				});
			}
			else if (name.indexOf("_single") > -1) {
				newStateProps.fields.customer_autogiro_single_funds[fundIndexInArray]["customer_autogiro_single_fund_" + (fundIndexInArray + 1) + "_name"] = selectedFund.label;
				newStateProps.fields.customer_autogiro_single_funds[fundIndexInArray]["customer_autogiro_single_fund_" + (fundIndexInArray + 1) + "_isin"] = selectedFund.isin;

				/**
				 * Update state with new values. We reset the amount field to the same value as it already has because
				 * this triggers a revalidation of the form. This is a hack that works, made because of lack of time.
				 * If you find a better way of triggering revalidation, feel free to change.
				 */
				const resetValue = this.state.fields.customer_autogiro_single_amount;
				this.setState(newStateProps, function () {
					CobHelpers.onViewFieldChange.call(this, "customer_autogiro_single_amount", resetValue);
				});
			}
			else {
				console.log("_onNameIsinChange :: invalid type " + name);
			}
		}
	};

	_onAddFund = (type) => {
		if (type === "single") {
			this.setState({
				autogiroSingleFundsActive: this.state.autogiroSingleFundsActive + 1,
				autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_single_funds,
					this.state.autogiroSingleFundsActive + 1,
					"single"
				)
			});
		}
		else if (type === "monthly") {
			this.setState({
				autogiroMonthlyFundsActive: this.state.autogiroMonthlyFundsActive + 1,
				autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_monthly_funds,
					this.state.autogiroMonthlyFundsActive + 1,
					"monthly"
				)
			});
		}
		else {
			console.log("_onAddFund :: invalid type " + type);
		}
	};

	_onRemoveFund = (type) => {
		if (type === "single") {
			let activeFundsBeforeRemove = this.state.autogiroSingleFundsActive;
			let newStateProps = {
				autogiroSingleFundsActive: activeFundsBeforeRemove - 1,
				autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_single_funds,
					activeFundsBeforeRemove - 1,
					"single"
				),
				fields: this.state.fields
			};

			/**
			 * Clear all rows above the row that we just removed
			 */
			for (let i = (activeFundsBeforeRemove - 1); i < newStateProps.fields.customer_autogiro_single_funds.length; i++) {
				newStateProps["customer_autogiro_single_fund_" + (i + 1) + "_index"] = -1;
				newStateProps.fields.customer_autogiro_single_funds[i][["customer_autogiro_single_fund_" + (i + 1) + "_name"]] = "";
				newStateProps.fields.customer_autogiro_single_funds[i][["customer_autogiro_single_fund_" + (i + 1) + "_isin"]] = "";
				newStateProps.fields.customer_autogiro_single_funds[i][["customer_autogiro_single_fund_" + (i + 1) + "_percentage"]] = "0";
			}

			this.setState(newStateProps);
		}
		else if (type === "monthly") {
			let activeFundsBeforeRemove = this.state.autogiroMonthlyFundsActive;
			let newStateProps = {
				autogiroMonthlyFundsActive: activeFundsBeforeRemove - 1,
				autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(
					this.state.fields.customer_autogiro_monthly_funds,
					activeFundsBeforeRemove - 1,
					"monthly"
				),
				fields: this.state.fields
			};

			/**
			 * Clear all rows above the row that we just removed
			 */
			for (let i = (activeFundsBeforeRemove - 1); i < newStateProps.fields.customer_autogiro_monthly_funds.length; i++) {
				newStateProps["customer_autogiro_monthly_fund_" + (i + 1) + "_index"] = -1;
				newStateProps.fields.customer_autogiro_monthly_funds[i][["customer_autogiro_monthly_fund_" + (i + 1) + "_name"]] = "";
				newStateProps.fields.customer_autogiro_monthly_funds[i][["customer_autogiro_monthly_fund_" + (i + 1) + "_isin"]] = "";
				newStateProps.fields.customer_autogiro_monthly_funds[i][["customer_autogiro_monthly_fund_" + (i + 1) + "_percentage"]] = "0";
			}

			this.setState(newStateProps);
		}
		else {
			console.log("_onAddFund :: invalid type " + type);
		}

	};

	_onPercentageSingleFieldChange = (name, value) => {
		const index = name.substring(0, name.indexOf("_"));
		const fieldName = name.substring(name.indexOf("_") + 1);

		if (value < 0 || value === "") {
			value = 0;
		}
		value = parseInt(value, 10);


		if (name.indexOf("_monthly") > -1) {
			const newFunds = this.state.fields.customer_autogiro_monthly_funds;
			newFunds[index][fieldName] = value;

			this.setState({
				fields: {
					...this.state.fields,
					customer_autogiro_monthly_funds: newFunds
				},
				autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(newFunds, this.state.autogiroMonthlyFundsActive, "monthly")
			});
		}
		else if (name.indexOf("_single") > -1) {
			const newFunds = this.state.fields.customer_autogiro_single_funds;
			newFunds[index][fieldName] = value;

			this.setState({
				fields: {
					...this.state.fields,
					customer_autogiro_single_funds: newFunds
				},
				autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(newFunds, this.state.autogiroSingleFundsActive, "single")
			});
		}
		else {
			console.log("_onPercentageSingleFieldChange :: invalid type " + name);
		}
	};

	_calculateFundsPercentagesTotal(funds, fundsActive, type) {
		let percentagesSum = 0;
		for (let i = 0; i < fundsActive; i++) {
			const fundInfo = funds[i];
			percentagesSum += parseInt(fundInfo["customer_autogiro_" + type + "_fund_" + (i + 1) + "_percentage"], 10);
		}
		return percentagesSum;
	}

	_onFieldChange = (name, value) => {
		/**
		 * For the single deposit and monthly savings field treat zero as if the value has not been entered
		 */
		if ((name === 'customer_autogiro_single_amount' || name === 'customer_autogiro_monthly_amount') && value === "0") {
			value = "";
		}

		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			},
			autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal(
				this.state.fields.customer_autogiro_single_funds,
				this.state.autogiroSingleFundsActive,
				"single"
			),
			autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal(
				this.state.fields.customer_autogiro_monthly_funds,
				this.state.autogiroMonthlyFundsActive,
				"monthly"
			)
		});
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_fieldValidator = (name, value) => {
		return value.length > 0;
	};

	_getProductLabel() {
		return ProductPurchase2.productLabel;
	}
}

// PRIVATE FUNCTIONS
function _getFields() {
	let fieldsArray = [
		"checkbox_autogiro_single",
		"customer_autogiro_single_amount",

		"checkbox_autogiro_monthly",
		"customer_autogiro_monthly_amount"
	];

	for (let i = 1; i <= ProductPurchase2.maxNumberOfSelectableProducts; i++) {
		fieldsArray.push("customer_autogiro_single_fund_" + i + "_name");
		fieldsArray.push("customer_autogiro_single_fund_" + i + "_isin");
		fieldsArray.push("customer_autogiro_single_fund_" + i + "_percentage");

		fieldsArray.push("customer_autogiro_monthly_fund_" + i + "_name");
		fieldsArray.push("customer_autogiro_monthly_fund_" + i + "_isin");
		fieldsArray.push("customer_autogiro_monthly_fund_" + i + "_percentage");
	}

	return fieldsArray;
}

function _getInitialState() {
	if (this.props.prevState) {
		return {...this.props.prevState};
	}

	const fundsSingle = [];
	const fundsMonthly = [];

	for (let i = 1; i <= ProductPurchase2.maxNumberOfSelectableProducts; i++) {
		const fundPercentage = (i === 1) ? "100" : "0";

		fundsSingle.push({
			["customer_autogiro_single_fund_" + i + "_name"]: "",
			["customer_autogiro_single_fund_" + i + "_isin"]: "",
			["customer_autogiro_single_fund_" + i + "_percentage"]: fundPercentage
		});

		fundsMonthly.push({
			["customer_autogiro_monthly_fund_" + i + "_name"]: "",
			["customer_autogiro_monthly_fund_" + i + "_isin"]: "",
			["customer_autogiro_monthly_fund_" + i + "_percentage"]: fundPercentage
		});
	}

	let initialState = {
		textFieldExpanded: false,
		autogiroSingleFundsActive: 1,
		autogiroSingleFundsSharesTotal: 0,
		autogiroMonthlyFundsActive: 1,
		autogiroMonthlyFundsSharesTotal: 0,
		products: [],

		fields: {
			"checkbox_autogiro_single": {
				checked: false
			},
			"customer_autogiro_single_amount": "",
			"customer_autogiro_single_funds": fundsSingle,

			"checkbox_autogiro_monthly": {
				checked: false
			},
			"customer_autogiro_monthly_amount": "",
			"customer_autogiro_monthly_funds": fundsMonthly
		},
		validFields: {}
	};

	for (let i = 1; i <= ProductPurchase2.maxNumberOfSelectableProducts; i++) {
		initialState["customer_autogiro_single_fund_" + i + "_index:"] = -1;
		initialState["customer_autogiro_monthly_fund_" + i + "_index:"] = -1;
	}

	return initialState;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/ProductPurchase-2/alfakraft/ProductPurchase2.js